import { render, staticRenderFns } from "./addContractTypeSpec.vue?vue&type=template&id=85ffb902"
import script from "./addContractTypeSpec.vue?vue&type=script&lang=js"
export * from "./addContractTypeSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports